import { getExistingProductId } from '@/utils/productHistory';
import { getIsScreenPrintType } from '@/model/printType/getIsScreenPrintType';
import { SCREEN_PRINT_MIN_ITEM_COUNT } from '@/model/printType/screenPrintMinItemCount';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { selectConfigurations } from '@/redux/draft/getters/selectConfigurations';
import { StoreState } from '@/redux/types';
import { getBasketItemsByProductId } from './getBasketItemsByProductId';

export const getMinimumBasketItemCount = (state: StoreState) => {
  const hasConfigurationsWithScreenPrint = selectConfigurations(state).some((configuration) =>
    getIsScreenPrintType(configuration.printType)
  );

  if (hasConfigurationsWithScreenPrint) {
    let minItemCount = SCREEN_PRINT_MIN_ITEM_COUNT;
    const existingProductId = getExistingProductId(getDraft(state))?.id;
    if (existingProductId) {
      getBasketItemsByProductId(state, existingProductId).forEach(
        (basketItem) => (minItemCount = Math.max(1, minItemCount - basketItem.quantity))
      );
    }

    return minItemCount;
  }

  return 1;
};
